
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/whats-new",
      function () {
        return require("private-next-pages/whats-new.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/whats-new"])
      });
    }
  